import { Link, createRoute } from '@tanstack/react-router'
import { rootRoute } from './root'
import { InDevelopment } from '@lunary/ui-web/in-development'

export const historyRoute = createRoute({
  path: 'history',
  getParentRoute: () => rootRoute,
  component: () => (
    <InDevelopment
      icon="history"
      title="История"
      text="Здесь соберутся ваши карты дня и расшифровки за прошлые дни. Раздел скоро откроется."
    >
      <Link to="/daily-card">
        <button type="button">К карте дня</button>
      </Link>
    </InDevelopment>
  ),
})
